import { gql } from '@apollo/client';

const TOUCH = gql`
  mutation touchProvider {
    touchProvider {
      token
      id
    }
  }
`;

const GENERATE_CIRCLE_SO_CALLBACK = gql`
  mutation generateCircleSoCallback {
    generateCircleSoCallback {
      callback
      mustAcceptTerms
    }
  }
`;

const REPLY_TO_CONVERSATION = gql`
  mutation providerReplyToConversation($conversationId: String!, $customerId: Int, $status: String!, $assignedTo: Int, $text: String, $attachments: [ConversationThreadReplyAttachments], $userId: Int!, $isDraft: Boolean) {
    providerReplyToConversation(data: { conversationId: $conversationId, customerId: $customerId, status: $status, assignedTo: $assignedTo, text: $text, attachments: $attachments, userId: $userId, isDraft: $isDraft }) {
      ok
      redirectTo
    }
  }
`;

const ADD_NOTE_TO_CONVERSATION = gql`
  mutation providerNoteToConversation($conversationId: String!, $status: String!, $assignedTo: Int, $text: String, $attachments: [ConversationThreadReplyAttachments], $userId: Int!) {
    providerNoteToConversation(data: { conversationId: $conversationId, status: $status, assignedTo: $assignedTo, text: $text, attachments: $attachments, userId: $userId }) {
      ok
    }
  }
`;

const REASSIGN_CONVERSATION = gql`
  mutation providerReassignConversation($conversationId: String!, $assignedTo: Int) {
    providerReassignConversation(conversationId: $conversationId, assignedTo: $assignedTo) {
      ok
    }
  }
`;

const CHANGE_CONVERSATION_STATUS = gql`
  mutation providerChangeStatusConversation($conversationId: String!, $status: String!, $userId: Int) {
    providerChangeStatusConversation(conversationId: $conversationId, status: $status, userId: $userId) {
      ok
    }
  }
`;

const CHANGE_PROFILE = gql`
  mutation providerSaveProfile($patientFacingName: String, $bio: String, $question1: String, $question2: String, $education: String, $experience: String, $startingYear: String) {
    providerSaveProfile(patientFacingName: $patientFacingName, bio: $bio, question1: $question1, question2: $question2, education: $education, experience: $experience, startingYear: $startingYear) {
      ok
    }
  }
`;

const SEND_SMS_TO_PATIENT = gql`
  mutation providerSendSMS($id: String!, $message: String!) {
    providerSendSMS(id: $id, message: $message) {
      ok
      customError
    }
  }
`;

const IMPERSONATE = gql`
  mutation impersonateProvider($id: String!) {
    impersonateProvider(id: $id) {
      token
    }
  }
`;

const REPORT_NO_SHOW = gql`
  mutation reportNoShow($athenaId: String!, $appointmentDateTime: String!, $providerName: String!) {
    reportNoShow(athenaId: $athenaId, appointmentDateTime: $appointmentDateTime, providerName: $providerName) {
      ok
    }
  }
`;

const APPEND_CHART_ALERT = gql`
  mutation appendChartAlert($athenaId: String!, $noteToAdd: String!) {
    appendChartAlert(athenaId: $athenaId, noteToAdd: $noteToAdd) {
      ok
    }
  }
`;

export {
  IMPERSONATE,
  REPORT_NO_SHOW,
  TOUCH,
  GENERATE_CIRCLE_SO_CALLBACK,
  REPLY_TO_CONVERSATION,
  ADD_NOTE_TO_CONVERSATION,
  REASSIGN_CONVERSATION,
  CHANGE_CONVERSATION_STATUS,
  CHANGE_PROFILE,
  SEND_SMS_TO_PATIENT,
  APPEND_CHART_ALERT
};
